module.exports = __webpack_public_path__ + "static/media/refresh.9aba3d79.svg";